import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function FooterSection() {
  return (
    <footer className="bg-background-200/70 pt-16 md:pt-20 pb-8 px-6 md:px-10">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-14">
          <div>
            <h4 className="text-xs font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              Categorie 1
            </h4>
            <div className="w-8 h-px bg-foreground-300 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 4).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              Categorie 2
            </h4>
            <div className="w-8 h-px bg-foreground-300 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              {categories.slice(4, 8).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              Categorie 3
            </h4>
            <div className="w-8 h-px bg-foreground-300 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              {categories.slice(8, 12).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              Link Utili
            </h4>
            <div className="w-8 h-px bg-foreground-300 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              {categories.slice(12).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
              <Link
                to="/articolo/"
                className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
              >
                Guida Completa
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap"
              >
                itaobuy sheet
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-end justify-between pt-8 border-t border-background-300/60">
          <div>
            <span className="block font-heading text-4xl md:text-5xl font-bold text-foreground-300 leading-none tracking-tight">
              Itaobuy
            </span>
            <span className="block font-heading text-4xl md:text-5xl font-bold text-foreground-300 leading-none tracking-tight">
              Spreadsheet
            </span>
            <div className="flex items-center gap-3 mt-3">
              <div className="w-8 h-px bg-foreground-300"></div>
              <span className="text-xs text-foreground-500">
                La risorsa italiana più completa
              </span>
            </div>
          </div>

          <div className="flex flex-col md:flex-row items-start md:items-center gap-4 mt-6 md:mt-0">
            <span className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} Itaobuy Spreadsheet Italia
            </span>
            <div className="flex items-center gap-4">
              <span className="text-foreground-400 hover:text-foreground-700 transition-colors cursor-default" aria-label="Pinterest">
                <i className="ri-pinterest-line text-lg"></i>
              </span>
              <span className="text-foreground-400 hover:text-foreground-700 transition-colors cursor-default" aria-label="Instagram">
                <i className="ri-instagram-line text-lg"></i>
              </span>
              <span className="text-foreground-400 hover:text-foreground-700 transition-colors cursor-default" aria-label="YouTube">
                <i className="ri-youtube-line text-lg"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}